import { SuperBillControllerApi } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
export const useInvoiceMailWithPaymentLink = () =>
  useMutationWithLoading(
    async ({
      superBillId,
      invoiceSentToPatient,
    }: {
      superBillId: string;
      invoiceSentToPatient?: boolean;
    }) =>
      new SuperBillControllerApi(getConfigObject()).sendInvoiceEmail(
        superBillId,
        invoiceSentToPatient,
        getXtenantId()
      )
  );
